module.exports = __webpack_public_path__ + "img/vol06_cup01_cover01.5c35cb7f.jpg";